import { SuccessPaymentModal } from '@/features/success-payment-modal';
import { DashboardWrongModalContent } from '@/features/wrong-modal';

import { ArrowLeft } from '@/shared/assets';
import { PAYMENT_ERROR_MESSAGES } from '@/shared/lib';
import { DashboardDialogProps, Header, SmallCloseButton } from '@/shared/ui';

import { AddMoneyStep } from '../../../model/types';
import { AddMoneyStore } from '../../../model/useAddMoney';
import { AddMoneyContent } from './add-money-modal';
import { AddMoneyRequisitesForSend } from './add-money-requisites';
import { AddMoneyAccountContent } from './add-money-select';
import { CreditCardContent } from './credit-card-modal';

interface AddMoneyProps extends AddMoneyStore {
  onDone?: VoidFunction;
  onBack: () => void;
  isFirst: boolean;
  tab: string;
  setTab: (value: string) => void;
}

export const getAddMoneyProps = ({
  onDone,
  step,
  setStep,
  amount,
  setAmount,
  setAccount,
  resetCardInfo,
  onBack,
  isFirst,
}: AddMoneyProps) => {
  const handleClose = () => {
    if (step === 'success') {
      setStep('amount');
      setAmount(0);
      setAccount(null);
      onDone?.();
      return;
    }
    if (step === 'amount') {
      setAmount(0);
      return;
    }
    if (step === 'error' || step === 'no_funds') {
      setStep('card');
      return;
    }
    if (step === 'details') {
      setStep('account');
      return;
    }
    onDone?.();
  };
  const addMoneyFlowItems: Record<AddMoneyStep, DashboardDialogProps> = {
    amount: {
      title: 'add money',
      disableOutsideClick: !isFirst,
      content: <AddMoneyContent />,
      animationProps: {
        id: 'add money',
        isFirst: isFirst,
      },
      hideCloseButton: !isFirst,
      serviceButton: !isFirst
        ? {
            icon: <ArrowLeft className="!h-6 !w-6" />,
            onClick: () => {
              onBack();
            },
          }
        : undefined,
    },
    card: {
      title: 'credit card',
      content: <CreditCardContent />,
      hideCloseButton: true,
      serviceButton: {
        icon: <ArrowLeft className="!h-6 !w-6" />,
        onClick: () => {
          resetCardInfo();
          setStep('amount');
        },
      },
      animationProps: {
        id: 'credit card',
      },
    },
    account: {
      contentClassName: 'gap-0 max-h-[600px]',
      header: (
        <Header
          className="p-5"
          title="Choose currency"
          action={{
            as: 'custom',
            render: <SmallCloseButton />,
          }}
        />
      ),
      hideCloseButton: true,
      content: (
        <AddMoneyAccountContent
          onSelect={() => {
            setStep('details');
          }}
          onClose={() => onDone?.()}
        />
      ),
    },
    details: {
      content: <AddMoneyRequisitesForSend />,
      isFullscreen: true,
      modalProps: { classNames: { wrapper: 'bg-transparent' } },
      serviceButton: {
        icon: <ArrowLeft className="!h-6 !w-6" />,
        onClick: () => {
          handleClose();
        },
        isMobile: true,
      },
    },
    success: {
      hideCloseButton: true,
      headerProps: { className: 'min-h-[60px]' },
      content: (
        <SuccessPaymentModal
          onDone={handleClose}
          mainContent={
            <div className="flex flex-col gap-4 text-center">
              {/* <Heading variant="l">
                +{amount} {account?.symbol}
              </Heading> */}
              {/* <Typography variant="16-r">
                Money is on it’s way to your&nbsp;{account?.code}&nbsp;account
              </Typography> */}
            </div>
          }
        />
      ),
      animationProps: {
        id: 'success',
      },
    },
    error: {
      headerProps: { className: 'min-h-[60px]' },
      content: <DashboardWrongModalContent onClose={() => null} />,
      serviceButton: {
        icon: <ArrowLeft className="!h-6 !w-6" />,
        onClick: () => {
          setStep('card');
        },
      },
      animationProps: {
        id: 'error',
      },
    },
    no_funds: {
      headerProps: { className: 'min-h-[60px]' },
      content: (
        <DashboardWrongModalContent
          onClose={() => null}
          title={PAYMENT_ERROR_MESSAGES.NO_FUNDS_ON_CARD}
          headingVariant="s"
          descriptionText={
            PAYMENT_ERROR_MESSAGES.TRY_AGAIN_OR_CHOOSE_ANOTHER_METHOD
          }
          actionButton={{
            text: 'Choose another method',
            variant: 'base-500',
            size: 'lg',
          }}
        />
      ),
      serviceButton: {
        icon: <ArrowLeft className="!h-6 !w-6" />,
        onClick: () => {
          setStep('card');
        },
      },
      animationProps: {
        id: 'no-funds',
      },
    },
  };

  return addMoneyFlowItems[step];
};
